/* Bundle-Add-ons auf der PDP (snippets/bundle-addons.liquid).
   product-form.js ruft addSelected() direkt vor dem Bundle auf, damit der
   Warenkorb-Drawer danach Set und Extras zusammen zeigt. */

if (!customElements.get('bundle-addons')) {
  class BundleAddons extends HTMLElement {
    connectedCallback() {
      this.totalEl = this.querySelector('.bundle-addons__total');
      this.addEventListener('change', this.handleChange.bind(this));
    }

    handleChange(evt) {
      const select = evt.target.closest('.bundle-addons__variant');
      if (select) {
        const item = select.closest('.bundle-addons__item');
        const option = select.options[select.selectedIndex];
        const check = item.querySelector('.bundle-addons__check');
        check.value = option.value;
        check.dataset.price = option.dataset.price;
        item.querySelector('.bundle-addons__price').textContent = option.dataset.priceText;
        const compare = item.querySelector('.bundle-addons__compare');
        if (compare) {
          compare.textContent = option.dataset.compareText;
          compare.hidden = !option.dataset.compareText;
        }
        // Wer die Farbe waehlt, will den Artikel meist auch haben.
        check.checked = true;
      }
      this.updateTotal();
    }

    selectedChecks() {
      return [...this.querySelectorAll('.bundle-addons__check:checked')];
    }

    updateTotal() {
      const checks = this.selectedChecks();
      this.querySelectorAll('.bundle-addons__item').forEach((item) => {
        item.classList.toggle('is-selected', item.querySelector('.bundle-addons__check').checked);
      });
      if (!this.totalEl) return;
      if (checks.length === 0) {
        this.totalEl.hidden = true;
        return;
      }
      const cents = checks.reduce((sum, check) => sum + Number(check.dataset.price || 0), 0);
      const label = checks.length === 1 ? '1 Extra' : `${checks.length} Extras`;
      this.totalEl.textContent = `${label} ausgewählt: + ${BundleAddons.formatMoney(cents)}`;
      this.totalEl.hidden = false;
    }

    static formatMoney(cents) {
      const amount = (cents || 0) / 100;
      try {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
        }).format(amount);
      } catch (err) {
        return `${amount.toFixed(2)} €`;
      }
    }

    /**
     * Legt die angehakten Extras in den Warenkorb. Fehler blockieren das Set nicht.
     * @returns {Promise<boolean>} true, wenn etwas hinzugefuegt wurde.
     */
    async addSelected() {
      const items = this.selectedChecks().map((check) => ({ id: Number(check.value), quantity: 1 }));
      if (items.length === 0) return false;
      try {
        const response = await fetch(`${theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error(response.status);
        this.selectedChecks().forEach((check) => { check.checked = false; });
        this.updateTotal();
        return true;
      } catch (error) {
        console.log(error); // eslint-disable-line
        return false;
      }
    }
  }

  customElements.define('bundle-addons', BundleAddons);
}
